// src/firebase.js

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDWcv_nP9l8EyH5ID6bS0aSE1TMK3mQqXQ",
  authDomain: "davinese-dcf1a.firebaseapp.com",
  projectId: "davinese-dcf1a",
  storageBucket: "davinese-dcf1a.firebasestorage.app",
  messagingSenderId: "453731660844",
  appId: "1:453731660844:web:8cb993d4cf588c32600d89"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore (or other services you need)
export const db = getFirestore(app);
